module.exports = __webpack_public_path__ + "static/media/truck-tick.a7ce173e.svg";